import axios from "axios";


export const getSettings = async () => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        "/v1/admin/settings",    
        {
    
          headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };

export const updateSettings = async (settingsState) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.post(
        "/v1/admin/settings/update",
        { settings: settingsState ,"_method":"PUT"},
        {
          headers: {
            Authorization: "Bearer " + `${brear}`,
            app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
            lang: lang
          }
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  };
